import { Box, Card, Grid, Stack, Typography, useTheme } from "@mui/material";
import Title2 from '../../../components/title/title2';
import { useTranslation } from "react-i18next";
import companyData from '../../../data/company.json';
import CountUp from '../../../components/effects/countUp/countUp';

const clientsLocales = "clients";

const LandingStats = () => {
    const theme = useTheme();
    const {t} = useTranslation();

    return (
        <>
            <Box
                sx={{
                    backgroundColor: theme.palette.background.paper,
                    pb: {xs: 3, md: 5},
                    position: 'relative'
                }}
                className="sectionDoubleSpacing"
            >
                <Stack
                    direction='column'
                    alignItems='center'
                    className="bodySideMargin1 sectionRadius sectionInSidePadding"
                    sx={{
                        backgroundColor: theme.palette.background.default
                    }}
                >
                    <Title2 title={t(`${clientsLocales}.title`)} description={t(`${clientsLocales}.description`)}/>

                    <Grid
                        direction='row'
                        container
                        spacing={{xs: 1.5, md: 3}}
                    >
                        <Grid
                            size={{xs: 12, md: 6}}
                        >
                            <StatBox
                                title={new Date().getFullYear() - companyData.stats.founded}
                                description={t(`${clientsLocales}.experience`)}
                                inverse
                                index={2}
                                suffixValue="+"
                            />
                        </Grid>

                        <Grid
                            size={{xs: 12, md: 6}}
                        >
                            <StatBox
                                title={companyData.stats.countries}
                                description={t(`${clientsLocales}.countries`)}
                                index={0}
                                suffixValue="+"
                            />
                        </Grid>

                        <Grid
                            size={{xs: 12, md: 6}}
                        >
                            <StatBox
                                title={companyData.stats.chauffeurGuides}
                                description={t(`${clientsLocales}.chauffeurGuides`)}
                                index={1}
                                suffixValue="+"
                            />
                        </Grid>

                        <Grid
                            size={{xs: 12, md: 6}}
                        >
                            <StatBox
                                title={companyData.stats.bookings}
                                description={t(`${clientsLocales}.bookings`)}
                                index={3}
                                inverse
                                suffixValue="+"
                            />
                        </Grid>
                    </Grid>
                </Stack>
            </Box>
        </>
    );
}

export default LandingStats;

const StatBox = ({
    index,
    title,
    description,
    suffixValue="",
    inverse=false
}) => {
    const theme = useTheme();

    return (
        <>
            <Card
                elevation={0}
                sx={{
                    p: {xs: 2, md: 5},
                    backgroundColor: inverse ? theme.palette.primary.main : theme.palette.background.default,
                    border: `0.5px solid ${theme.palette.primary.main}`,
                    borderRadius: {xs: 4, md: 8},
                    minHeight: {xs: 0, md: 200}
                }}
                data-aos="zoom-in"
                data-aos-delay={index * 50}
            >
                <Stack
                    direction='column'
                    justifyContent='space-between'
                    alignItems='start'
                    width='100%'
                >
                    <Stack
                        direction='column'
                    >
                        <Typography
                            fontWeight={700}
                            fontSize={{xs: 50, md: 65, lg: 100}}
                            textAlign="left"
                            lineHeight={1.25}
                            color={inverse ? 'white' : theme.palette.text.primary}
                        >
                            {
                                Number.parseInt(title) < 10
                                ?
                                <span>0</span>
                                :
                                <></>
                            }

                            {
                                <CountUp
                                    from={Number.parseInt(title) < 1000 ? 0 : Number.parseInt(title) * 0.5}
                                    to={Number.parseInt(title)}
                                    separator=","
                                    direction="up"
                                    duration={1}
                                    className="count-up-text"
                                />
                            }

                            <span>{suffixValue}</span>
                        </Typography>

                        <Typography
                            fontWeight={400}
                            fontSize={{xs: 12, md: 14}}
                            textAlign="left"
                            lineHeight={1.5}
                            color={inverse ? 'white' : theme.palette.text.primary}
                        >
                            {description}
                        </Typography>
                    </Stack>
                </Stack>
            </Card>
        </>
    );
}